"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioCard = exports.RadioCardIcon = exports.RadioCardGroup = void 0;
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Col_1 = __importDefault(require("../Col"));
const Radio_1 = __importDefault(require("../Radio"));
var RadioCardGroup_1 = require("./RadioCardGroup");
Object.defineProperty(exports, "RadioCardGroup", { enumerable: true, get: function () { return RadioCardGroup_1.RadioCardGroup; } });
const RadioCardIcon = ({ icon }) => {
    if (!icon)
        return null;
    return react_1.default.createElement("div", { className: "gerudo-radio-card-icon" }, icon);
};
exports.RadioCardIcon = RadioCardIcon;
const RadioCard = ({ col, icon, name, size = "default", type, title, value, subtitle, children, checked: selected, disabled, className: customClassName, dataTestId, onChange, onClick, ariaLabel, 
// deprecated
reversed, }) => {
    const [checked, setChecked] = (0, react_1.useState)(selected);
    const isColumnType = type === "column";
    const className = (0, classnames_1.default)("gerudo-radio-card", {
        "gerudo-radio-card-active": checked,
        "gerudo-radio-card-disabled": disabled,
        "gerudo-radio-card-column": isColumnType,
        "gerudo-radio-card-reversed": type === "left" || reversed,
    }, customClassName);
    const onChangeHandler = (isChecked) => {
        if (onChange)
            onChange(value);
        setChecked(isChecked);
    };
    (0, react_1.useEffect)(() => {
        if (selected !== checked)
            setChecked(selected);
    }, [selected]);
    const isSizeHidden = size === "hidden";
    const hiddenRadio = isSizeHidden || isColumnType;
    const overrideCol = isColumnType ? { xs: 12, sm: 12, md: 8, lg: 6 } : {};
    const correctSize = isSizeHidden ? undefined : size;
    return (react_1.default.createElement(Col_1.default, Object.assign({ xs: 24, md: 12, xl: 6 }, overrideCol, col),
        react_1.default.createElement("label", { className: className, "data-testid": dataTestId },
            icon && react_1.default.createElement("div", { className: "gerudo-radio-card-icon" }, icon),
            react_1.default.createElement("div", { className: "gerudo-radio-card-text" },
                title && react_1.default.createElement("p", null, title),
                subtitle && react_1.default.createElement("span", null, subtitle),
                children && react_1.default.createElement("div", { className: "gerudo-radio-card-text-children" }, children)),
            react_1.default.createElement(Radio_1.default, { size: correctSize, name: name, value: value, checked: checked, disabled: disabled, onChange: (e) => onChangeHandler(e.target.checked), onClick: () => onClick && onClick(value), "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : (typeof title === "string" ? title : undefined), className: (0, classnames_1.default)("gerudo-radio-card-radio", { "gerudo-radio-card-radio-hidden": hiddenRadio }) }))));
};
exports.RadioCard = RadioCard;
exports.default = RadioCard;
//# sourceMappingURL=index.js.map